var __TEMP__ = require('./_mapCacheClear.js');var mapCacheClear = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_mapCacheDelete.js');var mapCacheDelete = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_mapCacheGet.js');var mapCacheGet = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_mapCacheHas.js');var mapCacheHas = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_mapCacheSet.js');var mapCacheSet = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = MapCache;
